/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { DisplayValuePair } from "./display-value-pair";

export class CmpTaskCommentDto {
    cmpTaskCommentId: string = undefined;
    taskId: string = undefined;
    isCustomerVisible: boolean = undefined;
    createdBy: DisplayValuePair<string>;
    updatedBy: DisplayValuePair<string>;
    comment: string = undefined;
    insertedOn: Date = undefined;
    updatedOn: Date = undefined;
}
